import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";

const ModalConfirmation = ({
  page,
  openModal: { show, type },
  status,
  handleSubmit,
  handleClose,
}: {
  page: string;
  openModal: { show: boolean; type: "delete" | "disable" | "" };
  status: string;
  handleSubmit(): void;
  handleClose(): void;
}) => {
  const textByType: { [key: string]: string } = {
    category: "esta categoria",
    payment: "este medio de pago",
    user: "este usuario",
    product: "este producto",
    ingredient: "este ingrediente",
    promotion: "esta promoción",
  };
  
  const getDeleteText = () => {
    const text = "Estas seguro de que deseas eliminar";

    return `${text} ${textByType[page]}?`;
  };

  const getSwitchText = () => {
    const text = "Estas seguro de que deseas";
    const action = status === "enabled" ? "deshabilitar" : "habilitar";

    return `${text} ${action} ${textByType[page]}?`;
  };
  return (
    <Dialog onClose={handleClose} open={show}>
      <IconButton onClick={handleClose} className="close-icon">
        <span className="material-symbols-rounded">close</span>
      </IconButton>
      <Box sx={{ p: 4, mt: 3 }}>
        <Typography>
          {type === "delete" ? getDeleteText() : getSwitchText()}
        </Typography>

        <Grid
          container
          display="flex"
          justifyContent="end"
          alignItems="center"
          sx={{ mt: 3 }}
          spacing={1}
        >
          <Button
            color="secondary"
            variant="outlined"
            size="small"
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            color="secondary"
            variant="contained"
            size="small"
            onClick={handleSubmit}
          >
            Aceptar
          </Button>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default ModalConfirmation;
